

import React from 'react';
















const defaultValue = {
  assetsMap: new Map(),
  uploadItems: [],
  addAssetsToMap: void 0,
  addFileToQueue: void 0,
  addFilesToQueue: void 0,
  fetchAssets: void 0,
  removeAsset: void 0,
  cancelUpload: void 0,
  refreshAsset: void 0,
  updateAsset: void 0,
  subscribeToAssetTranscoded: void 0,
  updateAssetLocally: void 0
};

const UploaderContext = React.createContext(defaultValue);

export const UploaderProvider = UploaderContext.Provider;
export const UploaderConsumer = UploaderContext.Consumer;